import { render, staticRenderFns } from "./About.vue?vue&type=template&id=3c5ec825&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"
import style0 from "./About.vue?vue&type=style&index=0&id=3c5ec825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ec825",
  null
  
)

export default component.exports